// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "70d4b110f5f3";
export const BUILD_VERSION_NUMBER = 48;
